import { createApp } from "vue";
import filters from "./filters";
import App from "./App";
import router from "./router";
import store from "./store";
import * as apollo from "./plugins/graphql/apollo";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

const app = createApp(App);
app.config.globalProperties.$filters = filters;
app.use(store).use(router).use(apollo.provider).mount("#app");
